<template>
  <div 
    class="help"
  >
    <div class="iframe-container">
      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/9cggHN9oY9k?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Clients',
  props: {},
  data: function(){
    return {
    }
  },
  mounted: function(){
  },
  methods: {
  }
}
</script>

<style lang="scss">
  @import "../assets/css/_mixins.scss";
  @import "../assets/css/_variables.scss";
  @import '../assets/css/clients.scss';

  .help {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;

    .iframe-container {
      position: relative;
      padding-bottom: 56.25%;
      width: 100%;
      height: 0px;

      button {
        position: fixed;
        top: 10px;
        right: 10px;
        padding: 10px 20px;
        background-color: $color_orange;
        color: #3f3f3f;
        border: none;
        z-index: 101;
      }

      iframe {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        width: 100%;
        height: 100%;
      }
    }
  }
  
</style>
